import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import type { GetPlatformV1AuditLogsParams } from '@nucleus-commerce/api-client/platform';

import { auditLogApi } from '../api/audit-log-api';

import { auditLogKeys } from './audit-log-keys';

const PAGE_SIZE = 25;

export function auditLogQueryOptions(params: GetPlatformV1AuditLogsParams) {
  return infiniteQueryOptions({
    queryKey: auditLogKeys.list(params),
    queryFn: ({ pageParam }) =>
      auditLogApi.list({
        ...params,
        limit: PAGE_SIZE,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
  });
}

/** Newest first; "Load more" follows nextCursor. The filters are the URL's. */
export function useAuditLog(params: GetPlatformV1AuditLogsParams) {
  return useInfiniteQuery(auditLogQueryOptions(params));
}
